import { convertStringToBuffer } from '../commands-utils/convertStringToBuffer'
import { expire, expireat, pexpire, pexpireat } from './index'

function createGroupedArray(arr, groupSize) {
  const groups = []
  for (let i = 0; i < arr.length; i += groupSize) {
    groups.push(arr.slice(i, i + groupSize))
  }
  return groups
}

export function set(key, value, ...options) {
  const nx = options.indexOf('NX') !== -1
  const xx = options.indexOf('XX') !== -1
  const get = options.indexOf('GET') !== -1

  const filteredOptions = options.filter(
    option => option !== 'NX' && option !== 'XX'
  )

  if (nx && xx) throw new Error('ERR syntax error')
  if (nx && this.data.has(key)) {
    if (get) return this.data.get(key)
    else return null
  }

  if (xx && !this.data.has(key)) return null

  let result = 'OK'
  if (get) {
    result = this.data.has(key) ? this.data.get(key) : null
  }

  this.data.set(key, value)

  const expireOptions = new Map(createGroupedArray(filteredOptions, 2))

  // Handle different expiration options
  if (expireOptions.has('EX')) {
    expire.call(this, key, expireOptions.get('EX'))
  } else if (expireOptions.has('PX')) {
    pexpire.call(this, key, expireOptions.get('PX'))
  } else if (expireOptions.has('EXAT')) {
    expireat.call(this, key, expireOptions.get('EXAT'))
  } else if (expireOptions.has('PXAT')) {
    pexpireat.call(this, key, expireOptions.get('PXAT'))
  } else {
    this.expires.delete(key)
  }

  return result
}

export function setBuffer(...args) {
  const val = set.apply(this, args)
  return convertStringToBuffer(val)
}
